module.exports = __webpack_public_path__ + "static/media/YF05_0.ad0c2e78.jpg";